/* eslint-env browser */
import { isBrowser } from '../WebApi';
export * from './origin-node';
export { default } from './origin-node';
export const defaultValue = () => ({
    url: isBrowser ? document.referrer : '',
});
